// eslint-disable-next-line @typescript-eslint/no-unused-vars
const noop = (...a: unknown[]) => {
    // noop!
};

/// This is a dummy function to allow for the use of Tailwind CSS classes in the codebase. Should take multiple strings and return them as a single string.
const tw = (...args: string[]): string => args.join(" ");

export { noop, tw };
